module.exports = __webpack_public_path__ + "img/nazuna_404_.196106b6.png";